import axios from "axios";
import DataGrid, {
  Column,
  Editing,
  Form,
  LoadPanel,
  Lookup,
  MasterDetail,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NYList, saCatList } from "./data";
import ExtraPay from "./ExtraPay";

export default function Payroll() {
  const [dataSource, setDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/payroll/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/payroll/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/payroll/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/payroll/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  return (
    <DataGrid
      id="payrollGrid"
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Payroll"}
          confirmDeleteMessage={"Are you sure you want to delete this payroll?"}
        />
        <Popup title="Payroll" showTitle={true} height={200} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="payroll"
          height={"100%"}
        >
          <SimpleItem
            dataField={"apptDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            {/* <Label text={"발령일"} /> */}
            <Label text={"Appointment Date"} />
            {/* <RequiredRule message={"* 발령일을 입력해주세요."} /> */}
            <RequiredRule message={"* Appointment date is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"pd"}
            editorType="dxNumberBox"
            editorOptions={{
              showSpinButtons: true,
              showClearButton: true,
              min: 1,
              max: 31,
              defaultValue: 25,
              format: "#0일",
            }}
          >
            <Label text={"급여일"} />
          </SimpleItem>
          <SimpleItem
            dataField={"inclWageSys"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: NYList,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"포괄임금제 여부"} />
          </SimpleItem>
          <SimpleItem
            dataField={"saCat"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: saCatList,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"급여구분"} />
          </SimpleItem>
        </Form>
      </Editing>

      <MasterDetail enabled={true} component={ExtraPay} />

      <Column
        dataField={"apptDate"}
        // caption="발령일"
        caption="Appointment Date"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column dataField={"pd"} caption="급여일" dataType={"number"} />
      <Column dataField={"inclWageSys"} caption="포괄임금제 여부">
        <Lookup dataSource={NYList} valueExpr="id" displayExpr={"name"} />
      </Column>
      <Column dataField={"saCat"} caption="급여구분">
        <Lookup dataSource={saCatList} valueExpr="id" displayExpr={"name"} />
      </Column>
    </DataGrid>
  );
}
